import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-x4 flex items-center justify-center" }
const _hoisted_2 = ["onClick"]

import {
    BasketDeliveryAddress,
    CustomerDeliveryCheckOutDeliverable, PickAndPackCheckOutDeliverable,
} from '@/b2c/shared/api/server-apis';
import useCountries from '@/shared/address/useCountries';
import { useCheckout } from '@/b2c/checkout/useCheckout';
import { useStepReset } from '@/b2c/checkout/useStepReset';
import BasketDeliverableDialog from '@/b2c/basket/ui/BasketDeliverableDialog.vue';
import { useRequiredForm } from '@/shared/form/useRequiredForm';
import { computed, watch } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import siteContextService from '@/b2c/shared/site-context.service';
import BaseAddressForm from '@/b2c/shared/address/ui/BaseAddressForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutChangeAddress',
  props: {
    isOpen: { type: Boolean, default: false },
    deliverable: null
  },
  emits: ['close', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { isOpen: boolean, deliverable: CustomerDeliveryCheckOutDeliverable | PickAndPackCheckOutDeliverable }




const labels = useBlockLabels();
const { setDeliveryAddress, invoiceAddress } = useCheckout();
const { siteCountryCode, siteCountryName, loaded } = useCountries();
const postalCodeValidationRegEx = computed<string>(() => siteContextService.country.postalCodeRegex);

const initialValues = () => {
    return {
        country: siteCountryName.value,
        companyName: props.deliverable?.deliveryAddress?.buyer?.companyName || invoiceAddress.value?.buyer?.companyName || '',
        firstName: props.deliverable?.deliveryAddress?.buyer?.firstName || invoiceAddress.value?.buyer?.firstName,
        lastName: props.deliverable?.deliveryAddress?.buyer?.lastName || invoiceAddress.value?.buyer?.lastName,
        street: props.deliverable?.deliveryAddress?.address?.street || invoiceAddress.value?.address?.street,
        extraInformation: props.deliverable?.deliveryAddress?.address?.street2 || invoiceAddress.value?.address?.street2,
        hasLift: props.deliverable?.deliveryAddress?.address?.hasLift || invoiceAddress.value?.address?.hasLift,
        city: props.deliverable?.deliveryAddress?.address?.city || invoiceAddress.value?.address?.city,
        postalCode: props.deliverable?.deliveryAddress?.address?.postalCode || invoiceAddress.value?.address?.postalCode,
    };
};

const validationSchema = {
    firstName: 'required',
    lastName: 'required',
    city: 'required',
    street: 'required',
    postalCode: {
        postalCode: postalCodeValidationRegEx.value,
        required: true,
    },

};

const close = (): void => {
    emit('close');
};

const resetStep = useStepReset();

const { handleSubmit, setFieldValue, setValues } = useRequiredForm({
    validationSchema,
    initialValues: initialValues(),
});

// Wait for country names to be loaded
watch(loaded, (value) => {
    if (value) {
        setTimeout(() => {
            setFieldValue('country', siteCountryName.value);
        }, 100);
    }
}, { immediate: true });

watch(() => props.isOpen, (open) => {
    open && setValues(initialValues());
});

const submit = handleSubmit(async(form): Promise<void> => {
    const request: BasketDeliveryAddress = {
        address: {
            city: form.city,
            country: siteCountryName.value,
            countryCode: siteCountryCode.value,
            hasLift: form.hasLift,
            otherCountryName: '',
            postalCode: form.postalCode,
            unknownPostalCode: form.isUnknownPostalCode,
            street: form.street,
            street2: form.extraInformation,
        },
        buyer: {
            companyName: form.companyName,
            firstName: form.firstName,
            lastName: form.lastName,
            vatNumber: form.vatNumber,
        },
    };

    await setDeliveryAddress(props.deliverable.id, request);
    resetStep();
    close();
    emit('change');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasketDeliverableDialog, {
    "is-open": __props.isOpen,
    heading: _unref(labels).customerDeliveryShippingChangeAddressHeading,
    onClose: close
  }, {
    navigation: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "c-magic-line c-magic-line--underline mr-32",
          onClick: _withModifiers(close, ["prevent"])
        }, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressCancelButton), 9, _hoisted_2),
        _createElementVNode("button", {
          type: "submit",
          class: "c-button c-button--basket w-auto",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
        }, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressSubmitButton), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        id: "checkoutChangeAddress",
        name: "checkoutChangeAddress",
        class: "text-left mt-10",
        onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
      }, [
        _createVNode(BaseAddressForm, { "hide-vat-number": true })
      ], 32)
    ]),
    _: 1
  }, 8, ["is-open", "heading"]))
}
}

})